import React from 'react';
import styled from 'styled-components';

import { BaseLabel, RadioLabel } from '../../../../styles/styleUtils';

const Container = styled.div`
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
  align-items: center;
  flex-wrap: wrap;
`;

const RadioButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const RadioButton = styled.input`
  margin: 0;
`;

function DespesaType({ tipoDespesa, onTypeChange, disabled }) {
  return (
    <Container>
      <BaseLabel>Tipo da Despesa</BaseLabel>

      <RadioButtonWrapper>
        <RadioButton
          type="radio"
          name="tipoDespesa"
          value="avulsa"
          checked={tipoDespesa === 'avulsa'}
          onChange={onTypeChange}
          disabled={disabled}
        />
        <RadioLabel>Avulsa</RadioLabel>
      </RadioButtonWrapper>

      <RadioButtonWrapper>
        <RadioButton
          type="radio"
          name="tipoDespesa"
          value="parcelada"
          checked={tipoDespesa === 'parcelada'}
          onChange={onTypeChange}
          disabled={disabled}
        />
        <RadioLabel>Parcelada</RadioLabel>
      </RadioButtonWrapper>

      <RadioButtonWrapper>
        <RadioButton
          type="radio"
          name="tipoDespesa"
          value="recorrente"
          checked={tipoDespesa === 'recorrente'}
          onChange={onTypeChange}
          disabled={disabled}
        />
        <RadioLabel>Recorrente</RadioLabel>
      </RadioButtonWrapper>
    </Container>
  );
}

export default DespesaType;
